module.exports = __webpack_public_path__ + "img/importGradeExcelSample.a95b132b.png";